import React from "react";
import { Disclosure, Transition } from "@headlessui/react";
import { FaChevronDown } from "react-icons/fa";

export const FAQSection = ({ title, content }: { title: React.ReactNode; content: React.ReactNode }) => {
  return (
    <>
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="my-2 flex w-full justify-between rounded-lg px-4 py-2 text-left text-sm font-medium text-blue-500 focus:outline-none focus-visible:ring focus-visible:ring-blue-500/50">
              <span className="text-lg">{title}</span>
              <FaChevronDown
                className={`${
                  open ? "rotate-180 transform" : ""
                } h-5 w-5 transition-transform duration-200`}
              />
            </Disclosure.Button>
            <Transition
              show={open}
              enter="transition-opacity duration-500 ease-out"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity duration-100 ease-in"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Disclosure.Panel
                static
                className="px-4 pb-2 pt-2 text-sm text-blue-500"
              >
                {content}
              </Disclosure.Panel>
            </Transition>
          </>
        )}
      </Disclosure>
      <hr className="mx-[12px] my-4 border-t-[0.5px] border-blue-500" />
    </>
  );
};

export const FAQ = ({ copy }: { copy: { title: React.ReactNode; content: React.ReactNode }[] }) => {
  return (
    <section className="mt-10 grid grid-cols-12 gap-x-12 gap-y-8">
      <div className="col-span-6">
        <h1 className="mb-4 mt-8 flex w-full justify-center align-middle text-3xl font-bold text-blue-200">
          Frequently Asked Questions
        </h1>
        <div className="flex w-full justify-center">
          <h3 className="text-md mb-4 flex w-4/6 justify-center text-center align-middle text-blue-500">
            Have questions about what this is, how it works, or how to use this?
            Look no further!
          </h3>
        </div>
      </div>
      <div className="col-span-6 w-full px-4 pt-2">
        <div className="mx-auto w-full max-w-2xl rounded-2xl p-4">
          {copy.map((c: { title: React.ReactNode; content: React.ReactNode }, idx: number) => (
            <FAQSection {...c} key={idx} />
          ))}
        </div>
      </div>
    </section>
  );
};
